﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class SexoUserComponent {

    tabla: Tabla = {
        titulo: 'Sexo',
        endPoint:'/rest-api/user/sexo',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Sexo',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            }
        ]
    };

}
